import { fontSize } from '@core-ds/primitives';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import initializeComponent from '../Shared/react-initialize';
import Modal from './modal';

const PropText = styled.a`
   user-select: none;
   font-size: ${fontSize[1]};
`;

class WarningModal extends Component {
   state = {
      open: false,
   };

   open = () => {
      this.setState({ open: true });
   };

   close = () => {
      this.setState({ open: false });
   };

   render() {
      const { chemicals, warnings } = this.props;

      return (
         chemicals &&
         warnings && (
            <React.Fragment>
               <PropText onClick={this.open}>California Residents: Prop 65 WARNING</PropText>
               {this.state.open && (
                  <Modal close={this.close} chemicals={chemicals} warnings={warnings} />
               )}
            </React.Fragment>
         )
      );
   }
}

WarningModal.propTypes = {
   chemicals: PropTypes.arrayOf(PropTypes.string),
   warnings: PropTypes.string,
};

initializeComponent('WarningModal', WarningModal);
